export default __webpack_public_path__ + "static/media/kitchen4-afterD-1024w.706952c0.avif";